function isTransparent (str) {
  return str === 'transparent'
}

module.exports = isTransparent




//////////////////
// WEBPACK FOOTER
// ./node_modules/is-color/lib/isTransparent.js
// module id = 199
// module chunks = 0